exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PayForm {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between; }\n  .PayForm__loader {\n    height: 200px;\n    position: relative; }\n    .PayForm__loader .Loader {\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%); }\n", ""]);

